import React, { createContext, useContext } from "react"

const OrderFormApiContext = createContext(null)

export function OrderFormApiProvider({ api, children }) {
    return (
        <OrderFormApiContext.Provider value={api}>
            {children}
        </OrderFormApiContext.Provider>
    )
}

export function useOrderFormApi() {
    const api = useContext(OrderFormApiContext)
    if (!api) {
        throw new Error("useOrderFormApi must be used within an OrderFormApiProvider")
    }
    return api
}

